import { combineReducers } from "redux";
import { createItemReducer, createItemReducerParams } from "@mnjsplatform/data/lib/reducers/dataItemReducer";

export function peopleBoardReducer() {
    return combineReducers({
        PeopleBoard_ListSubForPO: createItemReducer("PeopleBoard", "PersonalCard.ListSubForNewPO", false),
        PeopleBoard_ListSubForPOParams: createItemReducerParams("PeopleBoard", "PersonalCard.ListSubForNewPO")
    });
}